/* ============================================================
   BOURGEOISIE — MAIN JS (Shopify)
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── Mobile nav ── */
  const toggle     = document.getElementById('navToggle');
  const mobileMenu = document.getElementById('navMobile');

  if (toggle && mobileMenu) {
    toggle.addEventListener('click', () => {
      const isOpen = mobileMenu.classList.toggle('open');
      toggle.classList.toggle('open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
    // close on link click
    mobileMenu.querySelectorAll('a').forEach(a =>
      a.addEventListener('click', () => {
        mobileMenu.classList.remove('open');
        toggle.classList.remove('open');
        document.body.style.overflow = '';
      })
    );
  }

  /* ── Active nav link (Shopify pathname-based) ── */
  const currentPath = window.location.pathname;
  document.querySelectorAll('.nav-links a').forEach(link => {
    const linkPath = link.getAttribute('href');
    if (!linkPath) return;
    // exact match or path starts with link (for collections, pages etc.)
    if (currentPath === linkPath ||
        (linkPath !== '/' && currentPath.startsWith(linkPath))) {
      link.classList.add('active');
    }
  });

  /* ── Nav: shadow on all pages, transparent on index only ── */
  const nav = document.querySelector('.nav');
  if (nav) {
    const isTransparent = nav.classList.contains('nav--transparent');
    const heroHeight    = document.querySelector('.video-hero')?.offsetHeight ?? 80;

    const onScroll = () => {
      const past = window.scrollY > (isTransparent ? heroHeight * 0.6 : 10);
      nav.classList.toggle('scrolled', past);
      if (isTransparent) {
        nav.classList.toggle('scrolled', past);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Button ripple effect ── */
  document.querySelectorAll('.btn').forEach(btn => {
    btn.addEventListener('click', function (e) {
      const rect   = this.getBoundingClientRect();
      const size   = Math.max(rect.width, rect.height) * 2;
      const x      = e.clientX - rect.left - size / 2;
      const y      = e.clientY - rect.top  - size / 2;
      const ripple = document.createElement('span');
      ripple.classList.add('btn-ripple');
      ripple.style.cssText = `width:${size}px;height:${size}px;left:${x}px;top:${y}px`;
      this.appendChild(ripple);
      ripple.addEventListener('animationend', () => ripple.remove());
    });
  });

  /* ── Scroll reveal with stagger ── */
  if ('IntersectionObserver' in window) {
    const selectors = [
      '.product-card',
      '.collection-card',
      '.lookbook-preview-item',
      '.section-header',
      '.collection-feature-text',
      '.feature-band-inner',
      '.newsletter',
      '.hero-text',
      '.policy-container',
    ];
    document.querySelectorAll(selectors.join(',')).forEach(el => {
      el.classList.add('reveal');
    });

    // Stagger siblings inside grids
    document.querySelectorAll('.product-grid, .collection-grid').forEach(grid => {
      grid.querySelectorAll('.reveal').forEach((card, i) => {
        if (i < 4) card.classList.add(`reveal-delay-${i + 1}`);
      });
    });

    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.07, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.reveal').forEach(el => io.observe(el));
  }

  /* ── Filter pills (shop page) ── */
  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      pill.closest('.filter-pills')
          .querySelectorAll('.filter-pill')
          .forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
    });
  });

  /* ── Policy tabs ── */
  document.querySelectorAll('.policy-tab').forEach(tab => {
    tab.addEventListener('click', () => {
      const target = tab.dataset.tab;
      document.querySelectorAll('.policy-tab').forEach(t => t.classList.remove('active'));
      document.querySelectorAll('.policy-content').forEach(p => p.classList.remove('active'));
      tab.classList.add('active');
      const panel = document.getElementById(target);
      if (panel) {
        panel.classList.add('active');
        panel.style.animation = 'none';
        panel.offsetHeight; // reflow
        panel.style.animation = 'tabFadeIn 0.3s ease forwards';
      }
    });
  });

  // inject tab fade keyframes once
  if (!document.getElementById('tabFadeStyle')) {
    const s = document.createElement('style');
    s.id = 'tabFadeStyle';
    s.textContent = '@keyframes tabFadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}';
    document.head.appendChild(s);
  }

  /* ── Duplicate marquee for seamless loop ── */
  const track = document.querySelector('.marquee-track');
  if (track) track.innerHTML += track.innerHTML;

  /* ── Smooth hero parallax ── */
  const heroImage = document.querySelector('.hero-image');
  if (heroImage) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      if (y < window.innerHeight) {
        heroImage.style.transform = `translateY(${y * 0.12}px)`;
      }
    }, { passive: true });
  }

  /* ── Smooth anchor scroll ── */
  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
